import clsx from 'clsx';
import { useCallback, useState } from 'react';
import { Tooltip } from 'react-tooltip';

import { Toggle } from 'components/elements/Toggle/Toggle';
import { cn } from 'utils/cn';

export type SettingItemProps = {
  fillIconBackground?: boolean;
  icon: JSX.Element;
  name: string;
  onChange: (newState: boolean) => void;
  state: 'default' | 'checked' | 'locked' | 'disabled';
  disabledMessage?: string;
};

const SettingItem = ({ name, state = 'default', onChange, icon, fillIconBackground, disabledMessage }: SettingItemProps) => {
  const isDisabled = state === 'disabled';
  const [isHovered, setIsHovered] = useState(false);
  const anchorId = `setting-anchor-${name.replace(/\s+/g, '-').toLowerCase()}`;

  const onClick = useCallback(() => {
    if (state === 'disabled' || state === 'locked') {
      return;
    }
    onChange(!state);
  }, [state, onChange]);

  return (
    <>
      <div
        className={clsx('flex items-center justify-between px-spl-7 py-spl-4', isDisabled && 'opacity-50')}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="flex items-center gap-spl-4">
          <div className={cn('p-spl-2 rounded-100', fillIconBackground && 'bg-bg-secondary')}>{icon}</div>
          <div id={anchorId} className="text-subheading-6 text-text-primary">
            {name}
          </div>
        </div>
        <div>
          <Toggle state={state} onClick={onClick} />
        </div>
      </div>
      <Tooltip anchorSelect={`#${anchorId}`} place="top" isOpen={isDisabled && isHovered} positionStrategy="fixed">
        <div className="max-w-[12rem] text-center">{disabledMessage}</div>
      </Tooltip>
    </>
  );
};

export default SettingItem;
